import { createLogger } from "utils/logging";
import { fetchRetry } from "utils/fetch";
import { captureErrorWithPayload } from "utils/error";
import { BenefitElement, defineElement } from "../BenefitElement";

const attributeNameId = "id";
const attributeNameOriginFeature = "feature";
const attributeNameTeam = "team";
const attributeNameVariationId = "variation-id";
const attributeNameProductId = "product-id";
const attributeNameSku = "sku";
const attributeNamePartnerId = "partner-id";

const log = createLogger("tag", "cashback");
const CASHBACK_ELEMENT_NAME = "ft9-cashback-v1";

const ERROR_KEY = "ft9-cashback-not-ok";

export class CashbackElement extends BenefitElement {
	protected async onInit(): Promise<void> {
		await this.callBackend();
	}

	protected async callBackend() {
		this.replaceChildren(); /*                       */

		const partnerId = this.getAttribute(attributeNamePartnerId);
		if (partnerId !== "1000000" && partnerId !== "999999999") {
			/*                                                                             */
			/*                                                                                     */
			/*                        */
			return;
		}
		const sku = this.getAttribute(attributeNameSku);
		if (!sku) {
			log.error("No sku provided, cannot load cashback.");
			captureErrorWithPayload("No sku provided", "tag", "cashback", ERROR_KEY);
			return;
		}

		const urlSearchParams = this.createSearchParams();
		log.info("Calling tag for %s with %s", this.id || "id-not-set", urlSearchParams.toString());

		try {
			const response = await fetchRetry({
				url: `/benefit-tag/cashback?${urlSearchParams}`,
				namespace: "cashback",
				fetchOptions: {
					headers: {
						Accept: "text/html;charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
					},
					priority: "high",
				},
				retryOptions: {
					limit: 2,
					delay: 50,
				},
			});
			if (!response.ok) {
				log.error("tag cashback endpoint returns a non ok response!", response.status);

				const labels = {
					url_search_params: urlSearchParams.toString(),
					tries: 1,
				};

				captureErrorWithPayload("callBackend error", "tag", "cashback", ERROR_KEY, response.status, labels);
				return;
			}
			this.innerHTML = await response.text();
			this.initCashback();
		} catch (error) {
			log.error("tag cashback request returns an error!", error);

			const labels = {
				url_search_params: urlSearchParams.toString(),
				tries: 3,
			};
			captureErrorWithPayload("callBackend error", "tag", "cashback", ERROR_KEY, error, labels);
		}
	}

	protected createSearchParams() {
		return this.buildSearchParams({
			originFeature: this.getAttribute(attributeNameOriginFeature),
			team: this.getAttribute(attributeNameTeam),
			sku: this.getAttribute(attributeNameSku),
			partnerId: this.getAttribute(attributeNamePartnerId),
		});
	}

	private initCashback() {
		const cashback = this.firstElementChild;
		if (!cashback || !(cashback instanceof HTMLElement)) {
			return;
		}

		if (cashback.dataset.expirationDate) {
			this.triggerReloadAt(cashback.dataset.expirationDate);
		}
	}
}

defineElement(CashbackElement, CASHBACK_ELEMENT_NAME, "ftnine_emergency_custom_element_disable_cashback");
